import {csrf} from "~/lib/tools";

const fetchMembers = async (org_id, payload) => {
    return await fetch(
        `/dashboard/organizations/${org_id}/members.json`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            },
            body: JSON.stringify(payload),
        })
        .then(async r => {
            let json = await r.json();
            return json.data;
        });
}
export {fetchMembers}